import React from "react";
import Bag from "oc-commons/Bag";

export default class Parts extends React.Component {

    constructor(props) {
        super(props);
        this.state = {parts:this._getParts()}
    }

    componentWillReceiveProps(props) {
       this.setState({parts:this._getParts()});
    }

    _getParts() {
        const allParts = [];
        this.props.arrangement.partsList.schraenke.forEach(schrank =>
            allParts.push(
                ...schrank.parts.find(part => part.name == this.props.lookUpKey).parts
            )
        );
        const partBag = Bag();
        const partMap = new Map();
        allParts.forEach(g => {
            partMap[g.Artikelnummer] = g.Name;
            partBag.inc(g.Artikelnummer);
        });

        return partBag.map((amount, artikelnummer) => amount + ' x ' + partMap[artikelnummer]);

    }

    render() {
        if (this.state.parts.length>0) {
            return (
                <React.Fragment>
                    <dt>{this.props.label}</dt>
                    <dd>
                        {
                            this.state.parts
                                .reduce((akku, curr, index) => <React.Fragment key={index}>{akku} <br/> {curr}</React.Fragment>)
                        }
                    </dd>
                </React.Fragment>
            );
        }
        return null;
    }
}